import script from "./IModal.vue?vue&type=script&lang=js"
export * from "./IModal.vue?vue&type=script&lang=js"

import "./IModal.vue?vue&type=style&index=0&id=f9c05d90&lang=less"

const __exports__ = script;

export default __exports__